module.exports = __webpack_public_path__ + "img/ear_plugs.png";